import { useState, useEffect, createContext, useContext } from "react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const CompanySettingsContext = createContext(null);

const DEFAULT_SETTINGS = {
  company_name: "Phygital",
  legal_entity_name: "",
  tagline: "Where Physical Meets Digital",
  support_email: "",
  phone: "",
  address: "",
  city: "",
  state: "",
  website: "",
  logo_url: "",
  social_links: {},
  legal: {},
  branding: {
    primary_color: "#7C3AED",
    accent_color: "#EC4899",
    font_family: "Inter"
  }
};

export const CompanySettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState(DEFAULT_SETTINGS);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const res = await fetch(`${API}/company-settings`);
        if (res.ok) {
          const data = await res.json();
          setSettings({ ...DEFAULT_SETTINGS, ...data });
          // Apply CSS variables for branding colors
          const root = document.documentElement;
          const branding = data.branding || {};
          if (branding.primary_color) root.style.setProperty('--brand-primary', branding.primary_color);
          if (branding.accent_color) root.style.setProperty('--brand-accent', branding.accent_color);
        }
      } catch (err) {
        console.error("Failed to load company settings:", err);
      }
      setLoaded(true);
    };
    fetchSettings();
  }, []);

  const refresh = async () => {
    try {
      const res = await fetch(`${API}/company-settings`);
      if (res.ok) {
        const data = await res.json();
        setSettings({ ...DEFAULT_SETTINGS, ...data });
      }
    } catch (err) {
      console.error("Failed to refresh company settings:", err);
    }
  };

  return (
    <CompanySettingsContext.Provider value={{ settings, loaded, refresh }}>
      {children}
    </CompanySettingsContext.Provider>
  );
};

export const useCompanySettings = () => {
  const ctx = useContext(CompanySettingsContext);
  if (!ctx) return { settings: DEFAULT_SETTINGS, loaded: false, refresh: () => {} };
  return ctx;
};
